import Vue from "vue";
import App from "./App.vue";
import routes from "./router/index.js";
import VueRouter from "vue-router";
import VueLazyLoad from "vue-lazyload";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/reset.less";
import Common from "./assets/script/utils/util.js";
import { Messenger } from "./assets/script/utils/message";
import { format } from "timeago.js";
import Clipboard from "clipboard";
import ShowMessage from "../src/components/edit/ShowMessage";
import insertConfig from "../src/assets/script/utils/editorControl";
import showLogin from "./components/dialogs/userLogin";
import showPrompt from "./components/dialogs/showLogin";
import http from "./assets/script/utils/http";

//全局登录提示框组件
Vue.component("showLogin", showLogin);
Vue.component("showPrompt", showPrompt);

import moment from "moment";
import Cookies from "js-cookie";
// import config from "./assets/script/config";
moment.locale("zh-cn");

Vue.prototype.insertConfig = insertConfig;

//自动获取文本框焦点
Vue.directive("focus", {
  // 当绑定元素插入到 DOM 中。
  inserted: function(el) {
    // 聚焦元素
    el.focus();
  }
});

//百度统计
var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?2d56acf42b4056540e59888ab8e03687";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

Vue.component("showBox", ShowMessage);

//复制文本组件
Vue.prototype.Clipboard = Clipboard;

//定义全局的过滤器 "changeTime":改变时间为几周前
Vue.filter("changeTime", function(dateStr) {
  return format(dateStr, "zh_CN");
});
//定义全局时间戳过滤器
Vue.filter("dateformat", function(dataStr, pattern = "YYYY-MM-DD HH:mm:ss") {
  return moment(dataStr).format(pattern);
});

//通信JS
Vue.prototype.$messenger = new Messenger(
  "_5118_Wyc_Box",
  "ai-5118-editor-messenger"
);
String.prototype.format = function(args) {
  let result = this;
  if (arguments.length > 0) {
    if (arguments.length === 1 && typeof args == "object") {
      for (let key in args) {
        if (args[key] !== undefined) {
          let reg = new RegExp("({" + key + "})", "g");
          result = result.replace(reg, args[key]);
        }
      }
    } else {
      for (let i = 0; i < arguments.length; i++) {
        if (arguments[i] !== undefined) {
          let reg = new RegExp("({)" + i + "(})", "g");
          result = result.replace(reg, arguments[i]);
        }
      }
    }
  }
  return result;
};

//复制内容
Vue.prototype.$copy = function(value) {
  let textarea = document.createElement("textarea");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "0";
  textarea.style.border = "none";
  textarea.style.outline = "none";
  textarea.style.resize = "none";
  textarea.style.background = "transparent";
  textarea.style.color = "transparent";
  textarea.value = value;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Common);

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach(async (to, from, next) => {
  if (router.app.$store.state.user.userToken === "") {
    let getReffParam = JSON.parse(Cookies.get(".5ce.referer") || "{}") || {};
    if (Object.keys(getReffParam).length <= 0) {
      insertConfig.addReff();
    }
    let setDomain = "5ce.com";
    if (window.location.href.indexOf("5ce.com") !== -1) {
      setDomain = "5ce.com";
    }
    if (window.location.href.indexOf("5118.com") !== -1) {
      setDomain = "5118.com";
    }
    if (window.location.href.indexOf("localhost") !== -1) {
      setDomain = "localhost";
    }
    let result = await http.post("/ai/aiInfo");
    if (result && result.data !== null) {
      let exp = new Date();
      exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
      Cookies.set("5ceinfo", JSON.stringify(result.data), {
        expires: exp,
        domain: setDomain
      });
    } else {
      // Cookies.remove("5ceinfo");
      let exp = new Date();
      exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
      Cookies.set("5ceinfo", "", {
        expires: exp,
        domain: setDomain
      });
    }
  }

  if (to.meta.allowPage) {
    // 判断该路由是否需要登录权限
    if (router.app.$store.state.user.userToken !== "") {
      // 判断是否登录了
      next();
    } else {
      // next();
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["AiEditor", "pages" + to.fullPath]);
    }
  }
  next();
});

Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  attempt: 1
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
